import { Box, Paper, Snackbar, Tab, TablePagination, Tabs, TextField } from '@mui/material'
import React from 'react'
import { Department } from 'enums/department'

import { useDispatch } from 'react-redux'
import API from '@aws-amplify/api'
import MuiAlert from '@mui/material/Alert'

import IncomingStockCards from 'components/premix/incomingStockCards'
import { VALUE_GUDANG_PACKAGING, VALUE_IN, VALUE_OUT } from 'enums/stockCard'
import StockCardPackagingHistory from 'components/stockCardPackagingHistory'
import PendingPurchaseOrders from 'components/purchaseOrder/pendingPurchaseOrders'
import { TYPE_PACKAGING } from 'components/purchaseOrder/purchaseOrderForm'
// import LoadPackagingPartAutocomplete from 'shared/autocomplete/loadPackagingPartAutocomplete'
import { IPackagingParts } from 'interfaces/IPackaging'

const lastMonth = new Date()
lastMonth.setMonth(lastMonth.getMonth() - 1)

export default function PackagingInventory(props: { department: Department }) {
  const { department } = props
  // history loading and alert message states are handled in the child history component
  const [packagingParts, setPackagingParts] = React.useState<IPackagingParts[]>(
    []
  )
  const [searchTerm, setSearchTerm] = React.useState('')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(50)
  const [totalCount, setTotalCount] = React.useState(0)

  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [tabValue, setTabValue] = React.useState('1')

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }

  const loadPackagingParts = async (search = '', pageNum = 0, pageSize = 50) => {
    try {
      const response = await API.get(
        'products',
        '/packaging/getPackagingPart',
        {
          queryStringParameters: {
            search: search,
            page: pageNum + 1,
            pageSize: pageSize,
            fuzzy: 'true',
            department: department,
          },
        }
      )

      // Handle both { data, count } and [...] formats
      const responseData = Array.isArray(response) ? response : (response.data || [])
      const responseCount = Array.isArray(response) ? response.length : (response.count || 0)

      console.log('PACKAGING_INVENTORY_DEBUG API Response:', response)
      console.log('PACKAGING_INVENTORY_DEBUG Extracted Data:', responseData)
      console.log('PACKAGING_INVENTORY_DEBUG Extracted Count:', responseCount)

      setPackagingParts(responseData)
      setTotalCount(Number(responseCount))
    } catch (e) {
      console.error('Failed to load packaging parts', e)
      setIsFailureSnackbarOpen(true)
    }
  }

  React.useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setPage(0)
      loadPackagingParts(searchTerm, 0, rowsPerPage)
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, rowsPerPage, department])

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
    loadPackagingParts(searchTerm, newPage, rowsPerPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRowsPerPage = parseInt(event.target.value, 10)
    setRowsPerPage(newRowsPerPage)
    setPage(0)
    loadPackagingParts(searchTerm, 0, newRowsPerPage)
  }

  // history loading and dialog are handled inside StockCardPackagingHistory

  const dispatch = useDispatch()
  React.useEffect(() => {
    const title = department
      ? `Gudang Kemasan (${department.toUpperCase()})`
      : 'Gudang Kemasan'
    dispatch({ type: 'SET_PAGE_TITLE', payload: title })
  }, [dispatch, department])



  return (
    <Box>
      <Paper>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
        >
          <Tab value={'0'} label="Konfirmasi Kartu Stok Masuk" />
          <Tab value={'4'} label="Konfirmasi Kartu Stok Keluar" />
          <Tab value={'1'} label="Tabel Stok Kemasan" />
          <Tab value={'5'} label="Daftar PO Pending" />
          {/* <Tab value={'2'} label="Kartu Stok Masuk Kemasan Manual" /> */}
          {/* <Tab value={'3'} label="Kartu Stok Keluar Kemasan Manual" /> */}
        </Tabs>
      </Paper>
      {tabValue === '0' && (
        <Paper>
          <IncomingStockCards
            type={VALUE_GUDANG_PACKAGING}
            inOutDirection={VALUE_IN}
            department={department}
          />
        </Paper>
      )}
      {tabValue === '1' && (
        <Paper>
          <Box p={2}>
            <TextField
              fullWidth
              label="Cari Kode atau Nama Part Kemasan"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          <Box mt={1} />
          <StockCardPackagingHistory data={packagingParts} />
          <Box p={2}>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
            />
          </Box>
        </Paper>
      )}
      {/* {tabValue === '2' && <IncomingPackagingStockCard />} */}
      {/* {tabValue === '3' && <OutgoingPackagingStockCard />} */}
      {tabValue === '4' && (
        <Paper>
          <IncomingStockCards
            type={VALUE_GUDANG_PACKAGING}
            inOutDirection={VALUE_OUT}
            department={department}
          />
        </Paper>
      )}
      {tabValue === '5' && (
        <PendingPurchaseOrders type={TYPE_PACKAGING} department={department} />
      )}
      {/* history dialog moved into StockCardPackagingHistory; no local dialog needed */}
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {}
        </MuiAlert>
      </Snackbar>
    </Box>
  )
}
